export const getFloatingGroupStyles = () => ({
  floatingGroup: {
    position: 'absolute',
    bottom: 63,
    width: 233,
    boxShadow: '4px 4px 4px rgba(0, 0, 0, 0.25)',
  },
  mobileView: {
    '@media only screen and (max-width: 600px)': {
      right: 0,
    },
  },
});
